export default {
  root: {
    borderRadius: '9px'
  }
}
